<template>
  <div>
    <navigation @on-open-menu="openMenu" @on-close-menu="closeMenu"></navigation>
    <main id="page-wrap" :class="isClosedMenu ? 'close-menu' : ''">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import navigation from "./navigation.vue";
import api from "../../services/api";

export default {
  components: {
    navigation
  },
  data: function() {
    return {
      routes: [],
      isClosedMenu: false
    };
  },
  created() {
    var self = this;
    this.$store.dispatch("me").then(res => {});
  },
  methods: {
    generalClick() {
      this.$root.$emit("root-click");
    },
    openMenu() {
      this.isClosedMenu = false;
    },
    closeMenu() {
      this.isClosedMenu = true;
    }
  }
};
</script>

